<template>
  <div class="card modal-card">
    <div class="modal-card-body is-paddingless">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('detailProduitReseau.popUpInfoTlpe.title', { face: face }) }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messagesError"
                             :error="error"
                             :canClose="false"
                             :title="'detailProduitReseau.popUpInfoTlpe.errors.title'"
                             @close="error = $event"/>
        <avertissement-msg-component :messages="messagesAvertissement"
                                     :canClose="false"
                                     :avertissement="avertissement"
                                     :title="'detailProduitReseau.popUpInfoTlpe' +
                                      '.avertissements.title'"
                                     @close="error = $event"/>
        <div class="center mgt-20px">
          <div class="button" @click="$parent.close()">
            {{ $t('general.button.close') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';
import traductionMessagesAvertissement from '@/services/bodac/produit/reseauTempo/traductionMessages/messagesAvertissement';
import traductionMessagesErreur from '@/services/bodac/produit/reseauTempo/traductionMessages/messagesErreurs';

export default {
  props: {
    face: {
      type: String,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: false,
      avertissement: false,
      messagesError: [],
      messagesAvertissement: [],
    };
  },
  components: {
    errorMsgComponent,
    avertissementMsgComponent,
  },
  mounted() {
    this.messagesAvertissement = traductionMessagesAvertissement(this.info.messagesAvertissement);
    this.messagesError = traductionMessagesErreur(this.info.messagesErreur);
    if (this.messagesAvertissement.length > 0) this.avertissement = true;
    if (this.messagesError.length > 0) this.error = true;
  },
};

</script>
